export default __webpack_public_path__ + "static/noi2019daniel1-695e7f92ef575a7ff9e87e646223007e.jpg";